module.exports = __webpack_public_path__ + "didnt-purchase-white.svg?bbc1577787e37cbb96aa8567b73556ee";